// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
export var cssClassToken = function (value) {
    if (value === null || value === undefined || String(value).length === 0) {
        return "global";
    }
    return String(value).replace(/[^a-zA-Z0-9_-]/g, "-");
};
export var entityClassName = function (entity, value) { return "seq-results-".concat(entity, "--").concat(cssClassToken(value)); };
